import { Navigate, Route, Routes } from "react-router-dom";
import Home from "../Screens/Home/Index";
import Package from "../Screens/Package/Index";
import MockTest from "../Screens/MockTest/Index";
// import RecordedClass from "../Screens/RecordedClasses/Index";
import Dashboard from "../Screens/Dashboard";
// import OnlineClass from "../Screens/OnlineClass/Index";
import MockTestDashboard from "../Screens/MockTestDashboard/Index";
import Login from "../Screens/Login/Index";
import SignUp from "../Screens/Signup/Index";
import PrivateRoute from "./PrivateRoute";
// import CourseMaterial from "../Screens/CourseMaterial/Index";
import AccessCourseMaterial from "../Screens/CourseMaterial/AccessCourseMaterial";
import TestPaper from "../Screens/TestPaper";
import PackageDetails from "../Screens/PackageDetails";
import LiveTest from "../Screens/LiveTest";
import TestAcknowledge from "../Screens/LiveTest/TestAcknowledge";
import TestSubmitted from "../Screens/LiveTest/TestSubmitted";
import LiveTestAttempted from "../Screens/LiveTestAttempted";
import PsychometricTest from "../Screens/PsychometricTest";
import PasswordForgot from "../Screens/FogotPassword/PasswordForgot";
import SetPassword from "../Screens/FogotPassword";
import { SitemapGenerator } from "../SitemapGenerator";
import Home2 from "../Screens/Home/index2";
import AboutUs from "../Screens/AboutUs";
import ContactUs from "../Screens/ContactUs";
import TermsAndCondition from "../Screens/TermsAndCondition";
import PrivacyPolicy from "../Screens/PrivacyPolicy";
import ErrorPage from "../Screens/ErrorPage";
import Cart from "../Screens/Cart";
import Order from "../Screens/Order";
import Purchases from "../Screens/Purchases";
import PracticeTest from "../Screens/PracticeTest";
import Material from "../Screens/Material";
import Attendance from "../Screens/Attendance";
// import OrderStatus from "../Screens/OrderStatus";

import LiveClass from "../Screens/LiveClasses";
import ErrorPage2 from "../Screens/ErrorPage2";
import Notification from "../Screens/Notification";
import OrderStatus from "../Screens/OrderStatus";
import LandingPage from "../Screens/LandingPage";
import StudentDetailsEdit from "../Screens/StudentEditDetails";
import LandingPage2 from "../Screens/LandingPage/LandingPage2";
import LandingPage3 from "../Screens/LandingPage/LandingPage3";
import Games1 from "../Screens/Games";
import Games2 from "../Screens/Games/Game2";
import Games3 from "../Screens/Games/Game3";
import Gurully from "../Screens/Gurully";
import Webinar from "../Screens/LandingPage/Webinar";
// import Trt from "../Screens/LandingPage/Trt";
import NewTrt from "../Screens/LandingPage/New_Trt";
import JoinZoom from "../Screens/ZoomApp";
import ZoomAccess from "../Screens/ZoomApp/zoomAccess";
import ZoomError from "../Screens/ZoomApp/ZoomError";
import ZoomDemoError from "../Screens/ZoomApp/ZoomDemoError";
import Masterclass from "../Screens/Form";
import Support from "../Screens/Support";
import RecordClass from "../Screens/RecordedClass";
import ChandigarhIelts from "../Screens/Chandigarh-Ielts";
import DelhiIelts from "../Screens/Delhi-Ielts";
import MobileLoginScreen from "../Screens/MobileLoginScrren";
import ChandigarhPte from "../Screens/Chandigarh-PTE";
import DelhiPte from "../Screens/Delhi-PTE";
import Book from "../Screens/Books";
import BookReader from "../Screens/Books/BookReader";
import BookReadDesktop from "../Screens/Books/BookReadDesktop";
import LandingPageDelhi from "../Screens/LandingPage/DelhiIelts";
import SignupVideo from "../Screens/Signup/video";
import FreeClassForm from "../Screens/Delhi-Ielts/Free_Class";
import TestStatus from "../Screens/Delhi-Ielts/achiveFree";
import FreeClassForm2 from "../Screens/Delhi-Ielts/Free_Class2";

export default function NavigationRoute() {
  return (
    <Routes>
      {/* <Route exact path="/pg1" element={<Home />} /> */}
      <Route exact path="/" element={<Home2 />} />
      <Route exact path="/contact-us" element={<ContactUs />} />
      <Route exact path="/about-us" element={<AboutUs />} />
      <Route exact path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route
        exact
        path="/student/books"
        element={<PrivateRoute> {<Book />}</PrivateRoute>}
      />
      <Route
        exact
        path="/student/book/:bookId"
        element={<PrivateRoute>{<BookReadDesktop />}</PrivateRoute>}
      />
      <Route
        path="/ielts-coaching-in-chandigarh"
        element={<ChandigarhIelts />}
      />
      <Route path="/pte-coaching-in-chandigarh" element={<ChandigarhPte />} />
      <Route path="/ielts-coaching-in-delhi" element={<DelhiIelts />} />
      <Route path="/pte-coaching-in-delhi" element={<DelhiPte />} />
      <Route path="/how-to-sign-up-and-login" element={<SignupVideo />} />
      <Route path="/free-ielts-pte-class" element={<FreeClassForm2 />} />
      <Route path="/tlat-test-status/:id" element={<TestStatus />} />

      <Route
        exact
        path="/terms-and-conditions"
        element={<TermsAndCondition />}
      />
      <Route path="/login" element={<MobileLoginScreen />} />
      <Route path="/web-login" element={<Login />} />
      {/* <Route path="/login/2" element={<MobileLoginScreen />} /> */}
      <Route path="/forgot/password" element={<PasswordForgot />} />
      <Route path="/set" element={<SetPassword />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/course" element={<Package />} />
      <Route path="/course/details/:id" element={<PackageDetails />} />
      <Route path="/test-papers" element={<TestPaper />} />
      <Route path="/mock-test" element={<MockTest />} />
      {/* <Route path="/recorded-classes" element={<RecordedClass />} /> */}
      <Route
        path="/recorded-classes"
        element={<PrivateRoute> {<RecordClass />} </PrivateRoute>}
      />
      <Route
        path="/dashboard"
        element={<PrivateRoute> {<Dashboard />} </PrivateRoute>}
      />
      {/* <Route
    path="/online-classes"
    element={<PrivateRoute>{<OnlineClass />} </PrivateRoute>}
  /> */}
      <Route
        path="/mock-test-dashboard"
        element={<PrivateRoute> {<MockTestDashboard />}</PrivateRoute>}
      />
      <Route
        path="/course-material"
        element={<PrivateRoute> {<Material />}</PrivateRoute>}
      />
      <Route
        path="/Attendance"
        element={<PrivateRoute> {<Attendance />}</PrivateRoute>}
      />
      <Route
        path="/course-material/access"
        element={<PrivateRoute> {<AccessCourseMaterial />}</PrivateRoute>}
      />
      <Route path="/T-LAT-acknowledge/:Id" element={<TestAcknowledge />} />
      <Route path="/T-LAT/:Id" element={<LiveTest />} />
      <Route path="/T-LAT-submitted" element={<TestSubmitted />} />
      <Route
        path="/Psychometric-Test"
        element={<PrivateRoute> {<PsychometricTest />}</PrivateRoute>}
      />
      <Route
        path="/student/support"
        element={<PrivateRoute> {<Support />}</PrivateRoute>}
      />
      <Route
        path="/T-LAT-answers"
        element={<PrivateRoute> {<LiveTestAttempted />}</PrivateRoute>}
      />
      <Route path="/cart" element={<Cart />} />
      <Route path="/Order/:OrderId" element={<Order />} />
      <Route
        path="/Purchases"
        element={<PrivateRoute> {<Purchases />}</PrivateRoute>}
      />
      <Route
        path="/Notification"
        element={<PrivateRoute> {<Notification />}</PrivateRoute>}
      />
      <Route
        path="/Academy"
        element={<PrivateRoute> {<PracticeTest />}</PrivateRoute>}
      />
      <Route
        path="/academy/:PackageId"
        element={<PrivateRoute> {<Gurully />}</PrivateRoute>}
      />
      <Route
        path="/live-classes"
        element={<PrivateRoute> {<LiveClass />}</PrivateRoute>}
      />
      <Route path="/student/order/status/:id" element={<OrderStatus />} />
      <Route
        path="/student/details-update/:id"
        element={<PrivateRoute>{<StudentDetailsEdit />} </PrivateRoute>}
      />
      <Route
        path="/ielts-pte-free-masterclass-in-chandigarh"
        element={<Masterclass />}
      />
      <Route path="/error" element={<ErrorPage />} />
      <Route path="/sitemap" element={<SitemapGenerator />} />
      <Route
        path="/ielts-pte-reality-test"
        element={
          <Navigate to="/ielts-reality-test-in-chandigarh" replace={true} />
        }
      />
      <Route
        path="/ielts-reality-test-in-chandigarh"
        element={<LandingPage />}
      />
      {/* <Route path="/ielts-reality-test-in-delhi" element={<LandingPageDelhi />} /> */}
      <Route path="/ielts-pte-reality-test-2" element={<NewTrt />} />
      <Route path="/language-assessment-test" element={<LandingPage3 />} />
      <Route path="/testifyi-ielts-webinar" element={<LandingPage2 />} />
      <Route
        path="/join-zoom/access"
        element={<PrivateRoute>{<JoinZoom />}</PrivateRoute>}
      />
      <Route
        path="/zoom/error"
        element={<PrivateRoute>{<ZoomError />}</PrivateRoute>}
      />
      <Route path="/zoom/error/demo" element={<ZoomDemoError />} />
      <Route path="/join-class/user/demo" element={<ZoomAccess />} />
      {/* <Route path="/trt" element={<Trt />} /> */}
      <Route path="/webinar" element={<Webinar />} />
      <Route path="/game-1" element={<Games1 />} />
      <Route path="/game-2" element={<Games2 />} />
      <Route path="/game-3" element={<Games3 />} />
      <Route path="/error" element={<ErrorPage />} />
      <Route path="/*" element={<ErrorPage2 />} />
    </Routes>
  );
}
